import {APIRequest} from "../APIRequest";
import {is_on_premises, parseKBSubdomain} from "../../App/utils";
import {clientUserData, kbUserData} from "../../utils";

export const API_URL = 'https://nzt65f5jcspq3lw656poy55wfe0codno.lambda-url.us-east-1.on.aws/';

export const spaLogger = async (message, stack = '') => {
    if (is_on_premises) return; // disable log on is_on_premises to avoid GDPR issues
    try {
        const url = window.location.href
        const parsedSubdomain = parseKBSubdomain()
        let userId, kbId;
        if (parsedSubdomain) {
            const {kbIdAsSubdomain, appsPrefix, mainDomain} = parsedSubdomain;
            const {myUserId} = kbUserData();
            userId = myUserId
            kbId = kbIdAsSubdomain
        } else {
            userId = clientUserData()?.userId;
        }

        const response = await APIRequest('post', API_URL, {
            // token,
            action: 'put',
            userId,
            kbId,
            url,
            message,
            stack
        }, { headers: { 'Content-Type': 'application/json' } });

        return response?.data;
    } catch (e) {
        console.log('Unable to log error')
    }

};